import * as actionTypes from '../actionTypes';

const initialState = {
  Status: '',
  Message: '',
  TheThing: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAN_THINGS:
      return {
        Message: '',
        TheThing: null,
        Status: ''
      }

    case actionTypes.TEMPORARY_SAVE_SOMTHING:
      return {
        Status: action.status,
        Message: action.message,
        TheThing: action.things
      }
    default:
      return state;
  }
}

export default reducer;